import * as THREE from "three";
import type { ToothContext } from "../../types/restoration";

export function extractToothContextFromMesh(
  mesh: THREE.Object3D,
  toothId?: string
): ToothContext {
  mesh.updateWorldMatrix(true, true);

  const box = new THREE.Box3().setFromObject(mesh);
  const center = new THREE.Vector3();
  const size = new THREE.Vector3();

  box.getCenter(center);
  box.getSize(size);

  const rotation = new THREE.Euler().setFromRotationMatrix(mesh.matrixWorld);

  return {
    toothId:
      toothId ||
      (mesh.userData?.toothId as string) ||
      mesh.name ||
      mesh.uuid,
    center: [center.x, center.y, center.z],
    size: [size.x, size.y, size.z],
    rotationEuler: [rotation.x, rotation.y, rotation.z],
    worldMatrix: [...mesh.matrixWorld.elements],
    meshName: mesh.name,
  };
}